import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimEntitlementAutoTopUpEventContainerModel,
} from '../../../../../../models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClaimEntitlementAutoTopUpEventService extends BaseApiTemplateService<ClaimEntitlementAutoTopUpEventContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/backoffice-ep';
    this.httpClient = http;
  }

  public deleteEvent(guid: string, eventType: string, visa: ApiVisa): Observable<ApiResponseModel<ClaimEntitlementAutoTopUpEventContainerModel>> {
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/processors/backoffice-ep';
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/processors/backoffice-ep';
    }
    return this.httpClient.delete<ApiResponseModel<ClaimEntitlementAutoTopUpEventContainerModel>>(
      this.apiUrl + '/' + guid + '?recurring_delete_type=' + eventType,
      this.getHttpHeader(visa)
    );
  }

  updateEvents(dtoObject: ClaimEntitlementAutoTopUpEventContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<ClaimEntitlementAutoTopUpEventContainerModel>>  {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/processors/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/processors/backoffice-ep';
    }

    return this.httpClient.put<BasicApiResponseModel<ClaimEntitlementAutoTopUpEventContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa));
  }

  createEvents(dtoObject: ClaimEntitlementAutoTopUpEventContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<ClaimEntitlementAutoTopUpEventContainerModel>>  {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/processors/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/processors/backoffice-ep';
    }

    return this.httpClient.post<BasicApiResponseModel<ClaimEntitlementAutoTopUpEventContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa));
  }

}
